export default __webpack_public_path__ + "static/media/icons.e9d4bd37.svg";